import * as S from './styles'

import {
  ChannelHelper,
  DealerAccount,
  accountKey,
  useChannel,
  formatterCurrencyUSD,
  DealerHelper,
} from '@monorepo/infra'
import { Icon, Spinner } from '@monorepo/components'
import { Link, useHistory } from 'react-router-dom'
import React, { useState } from 'react'
import { TableBody, TableRow } from '@material-ui/core'
import { UserHelper } from '@monorepo/infra'
import { colors } from '@monorepo/theme'

const CoopBar: React.FC = () => {
  const {
    selectedMasterDealerId,
    selectedChannel,
    accounts,
    coop,
    groups,
    setState,
  } = useChannel()
  const history = useHistory()
  const { isCoopUpdating } = coop
  const [showDialog, setShowDialog] = useState(false)

  const open = () => {
    setShowDialog(true)
  }

  const close = () => {
    setShowDialog(false)
  }

  const handleSelectChannel = (masterDealerId: string, channel: string) => {
    setState(masterDealerId, channel)
    close()
    history.push('/')
  }

  const getDialog = (allAccounts: DealerAccount[]) => {
    const selected = allAccounts?.find(
      (account) => account.masterDealerId === selectedMasterDealerId
    )

    if (!allAccounts?.length) return null
    return (
      <S.Dialog aria-label="Coop Dialog" isOpen={showDialog} onDismiss={close}>
        <S.CloseButton className="close-button" onClick={close}>
          x
        </S.CloseButton>
        <S.CurrentText>
          Current code:{' '}
          <S.CurrentTextCode>
            <S.CurrentTextCodeIdPart>
              {ChannelHelper.getMasterDealerId(
                selectedMasterDealerId,
                selectedChannel
              )}
            </S.CurrentTextCodeIdPart>
            {selected?.masterDealerName}
          </S.CurrentTextCode>
        </S.CurrentText>
        <S.TableTitle>Select a different code</S.TableTitle>
        <S.TableContainer>
          <S.Table aria-label="Dealer Channels Table">
            <TableBody>
              {/* Every master dealer AND channel the dealer holds. This used
                  to iterate only the first association, so anyone with a
                  second master dealer could never switch to it. */}
              {allAccounts.map((account) => {
                const isCurrent =
                  account.masterDealerId === selectedMasterDealerId &&
                  account.channel === selectedChannel
                return (
                  <TableRow key={accountKey(account)}>
                    <S.TableCell>
                      {ChannelHelper.getMasterDealerId(
                        account.masterDealerId,
                        account.channel
                      )}
                    </S.TableCell>
                    <S.TableCell>{account.channel}</S.TableCell>
                    <S.TableCell>{account.masterDealerName}</S.TableCell>
                    <S.TableCell>
                      <S.ChannelButton
                        onClick={() =>
                          handleSelectChannel(
                            account.masterDealerId,
                            account.channel
                          )
                        }
                        disabled={isCurrent}
                      >
                        {isCurrent ? 'Selected' : 'Select Channel'}
                      </S.ChannelButton>
                    </S.TableCell>
                  </TableRow>
                )
              })}
            </TableBody>
          </S.Table>
        </S.TableContainer>
      </S.Dialog>
    )
  }

  const getCoopButton = (
    allAccounts: DealerAccount[],
    masterDealerId: string,
    channel: string
  ) => {
    // Only one account to be in: show it as a label rather than a switcher.
    if ((allAccounts?.length ?? 0) <= 1) {
      return (
        <S.CoopNoButton>
          {ChannelHelper.getMasterDealerId(masterDealerId, channel)}
        </S.CoopNoButton>
      )
    }
    return (
      <>
        <S.CoopButton onClick={open}>
          {ChannelHelper.getMasterDealerId(masterDealerId ?? '', channel ?? '')}
          <Icon icon="Pencil" size={13} color={colors.lightGrey} />
        </S.CoopButton>
        {getDialog(allAccounts)}
      </>
    )
  }

  return (
    <S.CoopBarContainer>
      <S.GlobalMessage></S.GlobalMessage>
      <S.CoopContainer>
        {getCoopButton(accounts, selectedMasterDealerId, selectedChannel)}
        {!isCoopUpdating ? (
          ChannelHelper.canSeeCoop(
            selectedMasterDealerId,
            selectedChannel,
            UserHelper.isDealerAdmin(groups)
          ) || DealerHelper.hasAllowance(coop) ? (
            `Co-Op ${formatterCurrencyUSD.format(DealerHelper.getCoop(coop))}`
          ) : null
        ) : (
          <Spinner spinnerSize={4} />
        )}
        <S.CoopSpacer>|</S.CoopSpacer>
        <Link to="/contact">Support</Link>
      </S.CoopContainer>
    </S.CoopBarContainer>
  )
}

export default CoopBar
